import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import Link from 'flarum/common/components/Link';

import { canRequest, currentRequest, requestPath } from './utils/requestForm';
import n8nMark from './utils/n8nMark';

/**
 * n8card del sidebar del feed — el CTA «Solicitar acceso» donde el Spec §10 lo pone.
 *
 * «OCULTO SI YA ES MIEMBRO» (Spec §10) es solo una de las tres condiciones que decide
 * `canRequest()`; las otras dos son que exista grupo configurado y que haya sesion. Todas
 * viven en `utils/requestForm` y no aqui: esta tarjeta, D7 y el exito del Form A tienen que
 * responder lo mismo, y la unica forma de garantizarlo es que pregunten al mismo sitio.
 *
 * Y HASTA PKG-FORO-UX-BUNDLE NO LO GARANTIZABA. `canRequest()` entendia «ya es miembro» como
 * `isMember` a secas, mientras D7 lo entendia como «pertenece al grupo O ve su categoria». Al
 * ADMIN —que ve todas las etiquetas sin estar en ningun grupo— esta tarjeta le ofrecia
 * solicitar acceso y, tras probar el formulario una vez, se le quedaba fija en «en revision».
 * La formula unica es `hasN8nAccess()`; ver su comentario en `utils/requestForm`.
 *
 * CUANDO YA HAY SOLICITUD la tarjeta no desaparece: cambia a «en revision». Desaparecer seria
 * ambiguo — la persona no sabria si se envio o si la tarjeta nunca estuvo — y este es
 * precisamente el sitio del foro donde va a volver a buscarla.
 *
 * Prioridad -20 para caer DEBAJO de la lista de categorias: `collapsibleSidebar` ya baja `nav`
 * a -10, y `toArray()` ordena por prioridad descendente.
 */
export default function addN8nCard() {
  extend(IndexPage.prototype, 'sidebarItems', function (items: any) {
    const request = currentRequest();
    const pending = request?.status === 'pending';

    // Rechazada tambien pinta la tarjeta con el CTA: se puede volver a solicitar.
    if (!canRequest()) return;

    const t = (key: string) => app.translator.trans('umbral-comunidad.forum.n8card.' + key);

    items.add(
      'umbralN8nCard',
      <div className="CmN8card" data-cm-n8card={pending ? 'pending' : 'open'}>
        {/* T11 · decision A. El simbolo va JUNTO al chip y no dentro: `.cm-chip` lo comparten
            la landing, D7 y los estados de los dos formularios, y meterle un SVG dentro lo
            cambiaria en las cinco superficies de golpe. */}
        <div className="CmN8card-head">
          {n8nMark('cm-n8n-mark CmN8card-mark')}
          <span className="cm-chip cm-closed">{t('chip')}</span>
        </div>
        <p>{pending ? t('pending_body') : t('body')}</p>
        <Link className="cm-btn-n8n-out" href={requestPath()}>
          {pending ? t('pending_cta') : t('cta')}
        </Link>
      </div>,
      -20
    );
  });
}
